

      <div class="jui-modal-container" (click)="overlayClicked()"
          *ngIf="isOpen" [@appear]="'in'">
          <div class="modal-locator">
              <div class="main-container" (click)="stopBubble($event)"
                  [ngStyle]="boxStyle">
                  <div class="modal-inner">
                      <ng-content></ng-content>
                  </div>
              </div>
          </div>
      </div>
    